import React, { useState } from 'react';
import styled from 'styled-components';
import TopNav from '../components/TopNav';
import BottomTab from '../components/BottomTab';
import { useNavigate , useLocation} from 'react-router-dom';
import { FaInfoCircle, FaSearch, FaBarcode, FaRegHandPointer, FaTimes } from 'react-icons/fa';
import { Wrapper, Title } from '../styles/CommonStyles';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';  
import { bookRegType2Path } from '../common/enums';
import BookSearchResultPage from './BookSearchResultPage';
import BookDirectRegisterPage from './BookDirectRegisterPage';
import { getNativeWebview } from '../react-queries/queries';
import { scanBarcode } from '../api/native/NativeApis';

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 0 18px;
  margin: 0 24px 32px 24px;
  height: 56px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
`;

const SearchIcon = styled(FaSearch)`
  font-size: 20px;
  color: #888;
  margin-right: 12px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 18px;
  flex: 1;
  background: transparent;
  color: #222;
  &::placeholder {
    color: #bbb;
    opacity: 1;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  margin: 0 24px 32px 24px;
`;

const SearchButton = styled.button`
  flex: 1;
  background: #fff;
  border: 2px solid #ccc;
  border-radius: 12px;
  padding: 32px 0 24px 0;
  font-size: 18px;
  color: #888;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: border 0.2s;
  &:focus,
  &:active {
    border: 2px solid #1976d2;
    outline: none;
  }
`;

const RegisterButton = styled(SearchButton)`
  color: #888;
`;

const BarcodeIcon = styled(FaBarcode)`
  font-size: 38px;
  margin-bottom: 10px;
  color: #888;
`;

const HandIcon = styled(FaRegHandPointer)`
  font-size: 38px;
  margin-bottom: 10px;
  color: #888;
`;

const sampleBooks = [
  {
    thumb: '/book_sample1.jpeg',
    title: '동백꽃 둘다리 외',
    authors: '김유정, 주요섭, 전영택, 하근찬, 황순원',
    publisher: '서연비람',
    pubdate: '2018년 7월 15일',
  },
  {
    thumb: '/book_sample2.jpeg',
    title: '성냥팔이 소녀 외 7편 - 자신의 문해력에 맞춰서 읽는 Solution Book',
    authors: '안데르센',
    publisher: '자유지성사',
    pubdate: '2024년 12월 10일',
  },
  {
    thumb: '/book_sample3.jpeg',
    title: '남방우편기 - 초판본',
    authors: '생텍쥐페리',
    publisher: '더스토리',
    pubdate: '2024년 11월 10일',
  },
  {
    thumb: '/book_sample4.jpeg',
    title: '바스커빌가의 사냥개',
    authors: '아서 코난 도일',
    publisher: '민음사',
    pubdate: '2024년 11월 8일',
  },
  {
    thumb: '/book_sample5.jpeg',
    title: '데미안 - 미니북',
    authors: '헤르만헤세',
    publisher: '더클래식',
    pubdate: '2024년 10월 31일',
  },
  {
    thumb: '/book_sample6.jpeg',
    title: '인간 실격 - 미니북',
    authors: '다자이 오사무',
    publisher: '더클래식',
    pubdate: '2024년 10월 31일',
  },
];

/*
const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  position: relative;
  padding: 20px 20px 16px 20px;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

*/

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;



const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;


const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;




const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

/*
const CloseButton = styled.button`
  position: absolute;
  top: 7px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;
*/

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

function BookSearchFields({ search, setSearch, onSearch }) {
  return (
    <>
      <Title>어떤 책을 찾으시나요?</Title>
      <SearchBox>
        <SearchIcon />
        <SearchInput
          placeholder="책 제목을 검색해 보세요"
          value={search}
          onChange={e => setSearch(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') onSearch(); }}
        />
      </SearchBox>
    </>
  );
}

function EmbeddedBookSearchOnly({ search, setSearch, onSearch }) {
  return (
    <BookSearchFields search={search} setSearch={setSearch} onSearch={onSearch} />
  );
}

function BookSearchPageContent({ search, setSearch, onSearch, onBarcodeScan, onDirectRegister }) {
  return (
    <Wrapper>
      <BookSearchFields search={search} setSearch={setSearch} onSearch={onSearch} />
      <ButtonRow>
        <SearchButton onClick={onBarcodeScan}>
          <BarcodeIcon />
          바코드로 책 검색
        </SearchButton>
        <RegisterButton onClick={onDirectRegister}>
          <HandIcon />
          미검색 책 직접 등록
        </RegisterButton>
      </ButtonRow>
    </Wrapper>
  );
}

export default function BookSearchPage({ onClose , embeddedBookSearchOnly = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const bookRegType = params.get('bookRegType');
  const [search, setSearch] = useState('');
  const [showResultModal, setShowResultModal] = useState(false);
  const [showDirectRegisterModal, setShowDirectRegisterModal] = useState(false);
  const { showBack, setShowBack } = useNoobookContext();
  
  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(!onClose);
    return () => setShowBack(prevShowBack);
  }, []);

  const handleSearch = () => {
    if (search.trim()) {
      if (onClose) {
        // onClose가 있으면 모달로 BookSearchResultPage 표시
        setShowResultModal(true);
      } else {
        // onClose가 없으면 기존 방식으로 페이지 이동
        navigate(`/book-search-result?keyword=${encodeURIComponent(search.trim())}&bookRegType=${bookRegType}`, { replace: !!bookRegType });
      }
    }
  };

  const closeResultModal = (isbn, bookId) => {
    setShowResultModal(false);
    if (onClose) {
      onClose(isbn, bookId);
    }
  };

  const closeDirectRegisterModal = (bookId) => {
    setShowDirectRegisterModal(false);
    if (onClose) {
      onClose(null, bookId);
    }
  };

  const handleBarcodeScan = async () => {
    // 바코드 스캔 시뮬레이션 (실제로는 네이티브 바코드 스캔 기능 사용)
    // 임시로 테스트용 ISBN을 사용

  const isWebview = getNativeWebview();
  if(isWebview){
    const response = await scanBarcode();
    if (response.result === 0) {
      const scannedIsbn = response.data.code;
      //const scannedIsbn = '9791155506592'; // 테스트용 ISBN
      alert('scannedIsbn: ' + scannedIsbn);

      if (onClose) {
        onClose(scannedIsbn, null);
      } else {
        navigate(`${bookRegType2Path(bookRegType)}?isbn=${scannedIsbn}`, { replace: !!bookRegType });
      }
    } else {
      alert('바코드 스캔 실패: ' + response.result);
    }
  } else {
    alert('네이티브 바코드 스캔 기능을 사용할 수 없습니다.');
  }
};

  const handleDirectRegister = () => {
    if (onClose) {
      setShowDirectRegisterModal(true);
    } else {
      navigate(`/book-direct-register?bookRegType=${bookRegType}`, { replace: !!bookRegType });
    }
  };

return (
    <>
     {/*<TopNav showBack />*/}
   {embeddedBookSearchOnly ? (
     <EmbeddedBookSearchOnly
       search={search}
       setSearch={setSearch}
       onSearch={handleSearch}
     />
   ) : (
     <BookSearchPageContent
       search={search}
       setSearch={setSearch}
       onSearch={handleSearch}
       onBarcodeScan={handleBarcodeScan}
       onDirectRegister={handleDirectRegister}
     />
   )}
 {/*<BottomTab selected="home" onTabChange={handleTabChange} />*/}
      {/* 검색 결과 모달 */}
      {showResultModal && (
        <Modal>
          <ModalHeader>
            <ModalTitle>검색 결과</ModalTitle>
            <CloseButton onClick={()=>closeResultModal(null, null)}>
              <FaTimes />
            </CloseButton>
          </ModalHeader>
          <ModalContent>
            <BookSearchResultPage 
              keyword={search} 
              onClose={closeResultModal}
            />
          </ModalContent>
        </Modal>
      )}

      {/* 미검색 책 직접 등록 모달 */}
      {showDirectRegisterModal && (
        <Modal>
          <ModalHeader>
            <ModalTitle>미검색 책 직접 등록</ModalTitle>
            <CloseButton onClick={()=>closeDirectRegisterModal(null)}>
              <FaTimes />
            </CloseButton>
          </ModalHeader>
          <ModalContent>
            <BookDirectRegisterPage onClose={closeDirectRegisterModal} />
          </ModalContent>
        </Modal>
      )}
    </>
  );
} 